<template>
    <div>
        <v-autocomplete
            hide-no-data
            :search-input.sync="search"
            :items="items"
            :loading="loading"
            v-on:change="handleOnChange"
            return-object
            clearable
            v-model="model"
            v-bind="$props"
        >
            <!-- @click:clear="model = null" -->
        </v-autocomplete>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { isEmpty } from 'lodash';

import { getCustomer, searchCustomers } from "../../services/sales/customer";
export default {
    name: "CustomerSearch",
    data() {
        return {
            search: null,
            lastSearch: null,
            loading: false,
            selected: {},
        };
    },
    props: {
        value: {
            type: [String, Number],
        },
        itemText: {
            type: String,
            default: "name",
        },
        itemValue: {
            type: String,
            default: "id",
        },
        label: {
            type: String,
            default: "Search",
        },
        outlined: Boolean,
        hideDetails: [Boolean, String],
        width: String,
        dense: {
            type: Boolean,
            default: true,
        },
        rules: Array,
        backgroundColor: String,
        errorMessages: Array
    },
    computed: {
        ...mapState("sales/customer", {
            items: (state) => state.customerSearch,
        }),
        found() {
            if (this.search === null) return this.items;
            return this.items.filter((each) =>
                this.filter(each, this.search, each[this.itemText])
            );
        },
        dirty() {
            return this.lastSearch !== this.search;
        },
        model: {
            get() {
                return this.value;
            },
            set(val) {
                let value = !isEmpty(val) ? val.id : null;
                this.$emit("input", value);
            },
        },
    },
    watch: {
        search: {
            handler(search) {
                // empty search
                if (search === null) return;
                // when selected do not fire http.
                if (this.selected[this.itemText] === search) return;
                // has matching record.
                if (this.found.length > 0) return;
                // limit search characters
                if (this.search.trim().length < 3) return;
                // stop firing http if already fired.
                if (this.loading) return;
                // finally call search.
                this.callSearchCustomers();
            }
        },
        value(value) {
            console.log(value)
            if(!value) return;
            const found = this.items.find(each => each.id == value);
            if(!found) this.fetchCustomer(value);
        }
    },
    methods: {
        ...mapActions("sales/customer", ["setCustomersFromSearch"]),
        handleOnChange(val) {
            if (val === null) return;
            this.$emit("change", this.selected);
            this.selected = val[this.itemText];
        },
        handlerClear() {
            this.$emit('click:clear');
        },
        callSearchCustomers() {
            this.loading = true;
            this.lastSearch = this.search;
            searchCustomers({
                search: this.search,
            })
                .then((response) => {
                    // this.items = [...this.items, ...response.data];
                    if(Array.isArray(response.data)) {
                        this.setCustomersFromSearch(response.data);
                    } else {
                        throw new Error("Error Occured!")
                    }
                })
                .finally(() => {
                    this.loading = false;
                    if (this.dirty) return this.callSearchCustomers();
                });
        },
        filter(item, queryText, itemText) {
            return (
                itemText
                    .toLocaleLowerCase()
                    .indexOf(queryText.toLocaleLowerCase()) > -1
            );
        },
        async fetchCustomer(id) {
            this.loading = true;
            const resp = await getCustomer(id);
            this.setCustomersFromSearch([resp.data]);
            this.loading = false;
        },
        
    },
    mounted() {
        if(this.value){
            const found = this.items.find(each => each.id == this.value);
            if(!found) this.fetchCustomer(this.value);
        }
    }
};
</script>
